module.exports = __webpack_public_path__ + "img/nochanping copy.344e16d1.png";